export default __webpack_public_path__ + "static/media/shape_group_1.4758efcd.png";